
import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { title: '首页' }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/auth/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/finance',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'list',
        name: 'FinanceList',
        component: () => import('../views/finance/FinanceList.vue'),
        meta: { title: '财务记录' }
      },
      {
        path: 'add',
        name: 'FinanceAdd',
        component: () => import('../views/finance/FinanceAdd.vue'),
        meta: { title: '添加记录' }
      },
      {
        path: 'summary',
        name: 'FinanceSummary',
        component: () => import('../views/finance/FinanceSummary.vue'),
        meta: { title: '财务统计' }
      },
      {
        path: 'spendly-stats',
        name: 'FinanceSpendlyStats',
        component: () => import('../views/finance/FinanceSpendlyStats.vue'),
        meta: { title: '记账-每日消费' }
      },
      {
        path: 'trend',
        name: 'FinanceTrend',
        component: () => import('../views/finance/FinanceTrend.vue'),
        meta: { title: '历年趋势' }
      },
      {
        path: 'tutoring-fee',
        name: 'TutoringFee',
        component: () => import('../views/finance/TutoringFee.vue'),
        meta: { title: '补课费' }
      },
      {
        path: 'hk-transfer',
        name: 'HkTransfer',
        component: () => import('../views/finance/HkTransfer.vue'),
        meta: { title: '香港汇款' }
      },
      {
        path: 'salary-list',
        name: 'FinanceSalaryList',
        component: () => import('../views/salary/SalaryList.vue'),
        meta: { title: '工资明细' }
      },
      {
        path: 'salary-flow-check',
        name: 'FinanceSalaryFlowCheck',
        component: () => import('../views/salary/SalaryFlowCheck.vue'),
        meta: { title: '流水核对' }
      },
      {
        path: 'bonus',
        name: 'FinanceBonusList',
        component: () => import('../views/finance/BonusList.vue'),
        meta: { title: '奖金明细' }
      },
      {
        path: 'salary-trend',
        name: 'FinanceSalaryTrend',
        component: () => import('../views/salary/SalaryTrend.vue'),
        meta: { title: '工资趋势图' }
      },
      {
        path: 'salary-flow-trend',
        name: 'SalaryFlowTrend',
        component: () => import('../views/salary/SalaryFlowTrend.vue'),
        meta: { title: '流水收入分析' }
      },
      {
        path: 'overtime-trend',
        name: 'FinanceOvertimeTrend',
        component: () => import('../views/work/OvertimeTrend.vue'),
        meta: { title: '加班趋势图' }
      }
    ]
  },
  {
    path: '/stock',
    component: () => import('../views/Layout.vue'),
    redirect: '/stock/simulated-stock-list',
    children: [
      {
        path: 'investment-returns',
        name: 'InvestmentReturnList',
        component: () => import('../views/stock/InvestmentReturnList.vue'),
        meta: { title: '历史数据回溯' }
      },
      {
        path: 'analysis',
        name: 'StockAnalysis',
        component: () => import('../views/stock/StockAnalysis.vue'),
        meta: { title: '调仓分析' }
      },
      {
        path: 'hk-ipo',
        name: 'HkIpoList',
        component: () => import('../views/stock/HkIpoList.vue'),
        meta: { title: '港股打新' }
      },
      {
        path: 'hk-ipo-statistics',
        name: 'HkIpoStatistics',
        component: () => import('../views/stock/HkIpoStatistics.vue'),
        meta: { title: '打新收益统计' }
      },
      {
        path: 'gold-saving',
        name: 'GoldSaving',
        component: () => import('../views/stock/GoldSaving.vue'),
        meta: { title: '积存金管理' }
      },
      {
        path: 'hold-bond',
        name: 'HoldBondList',
        component: () => import('../views/stock/HoldBondList.vue'),
        meta: { title: '持股配债' }
      },
      {
        path: 'grid-strategy',
        name: 'GridStrategy',
        component: () => import('../views/stock/GridStrategy.vue'),
        meta: { title: '网格与加仓' }
      },
      {
        path: 'market-sentiment',
        name: 'MarketSentiment',
        component: () => import('../views/stock/MarketSentiment.vue'),
        meta: { title: '市场情绪' }
      },
      {
        path: 'simulated',
        name: 'SimulatedTrading',
        component: () => import('../views/xueqiu/SimulatedTrading.vue'),
        meta: { title: '模拟交易' }
      },
      {
        path: 'simulated-stats',
        name: 'SimulatedStats',
        component: () => import('../views/xueqiu/SimulatedStats.vue'),
        meta: { title: '模拟交易统计' }
      },
      {
        path: 'simulated-stock-list',
        name: 'SimulatedStockList',
        component: () => import('../views/xueqiu/SimulatedStockList.vue'),
        meta: { title: '模拟交易-股票列表' }
      },
      {
        path: 'simulated-daily',
        name: 'SimulatedDaily',
        component: () => import('../views/xueqiu/SimulatedDaily.vue'),
        meta: { title: '模拟交易盈亏走势' }
      },
      {
        path: 'simulated-kline',
        name: 'SimulatedKline',
        component: () => import('../views/xueqiu/SimulatedKline.vue'),
        meta: { title: '模拟交易历史K线' }
      },
      // 已下线的旧入口（/stock/list、/stock/add、/stock/distribution）统一兜底到默认页
      {
        path: ':pathMatch(.*)*',
        redirect: '/stock/simulated-stock-list'
      }
    ]
  },
  {
    path: '/asset',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'list',
        name: 'AssetList',
        component: () => import('../views/asset/AssetList.vue'),
        meta: { title: '资产列表' }
      },
      {
        path: 'add',
        name: 'AssetAdd',
        component: () => import('../views/asset/AssetAdd.vue'),
        meta: { title: '添加资产' }
      },
      {
        path: 'summary',
        redirect: '/asset/list'
      },
      {
        path: 'history',
        name: 'AssetHistory',
        component: () => import('../views/asset/AssetHistory.vue'),
        meta: { title: '资产历史' }
      },
      {
        path: 'exchange-rates',
        name: 'ExchangeRates',
        component: () => import('../views/asset/ExchangeRates.vue'),
        meta: { title: '汇率管理' }
      },
      {
        path: 'rate',
        name: 'AssetRate',
        component: () => import('../views/asset/AssetRate.vue'),
        meta: { title: '资产趋势' }
      }
    ]
  },
  {
    path: '/income',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'list',
        name: 'IncomeList',
        component: () => import('../views/income/IncomeList.vue'),
        meta: { title: '收益管理' }
      },
      {
        path: 'benchmark',
        name: 'IncomeBenchmark',
        component: () => import('../views/income/BenchmarkManage.vue'),
        meta: { title: '基准收益率' }
      },
      {
        path: 'compare',
        name: 'IncomeCompare',
        component: () => import('../views/income/IncomeCompare.vue'),
        meta: { title: '收益对比' }
      },
      {
        path: 'fire',
        name: 'FireCalculator',
        component: () => import('../views/income/FireCalculator.vue'),
        meta: { title: 'FIRE计算器' }
      },
      {
        path: 'category-return',
        name: 'CategoryReturn',
        component: () => import('../views/stock/CategoryReturn.vue'),
        meta: { title: '分类收益（雪球）' }
      }
    ]
  },
  {
    path: '/travel',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'list',
        name: 'TravelList',
        component: () => import('../views/travel/TravelList.vue'),
        meta: { title: '旅游记录' }
      },
      {
        path: 'add',
        name: 'TravelAdd',
        component: () => import('../views/travel/TravelAdd.vue'),
        meta: { title: '添加旅游记录' }
      },
      {
        path: 'china-map',
        name: 'ChinaMap',
        component: () => import('../views/travel/ChinaMap.vue'),
        meta: { title: '中国地图' }
      },
      {
        path: 'milestones',
        name: 'Milestones',
        component: () => import('../views/travel/Milestones.vue'),
        meta: { title: '重要时间点' }
      }
    ]
  },
  {
    path: '/life',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'ideas',
        name: 'IdeaBoard',
        component: () => import('../views/life/IdeaBoard.vue'),
        meta: { title: '想法' }
      },
      {
        path: 'tea',
        name: 'TeaTasting',
        component: () => import('../views/life/TeaTasting.vue'),
        meta: { title: '品茶' }
      },
      {
        path: 'books',
        name: 'NoteBooks',
        component: () => import('../views/note/NoteBooks.vue'),
        meta: { title: '读书' }
      },
      {
        path: 'books/add',
        name: 'NoteBookAdd',
        component: () => import('../views/note/NoteBookEdit.vue'),
        meta: { title: '添加读书' }
      },
      {
        path: 'books/:id',
        name: 'NoteBookDetail',
        component: () => import('../views/note/NoteBookDetail.vue'),
        meta: { title: '读书详情' }
      },
      {
        path: 'movies',
        name: 'NoteMovies',
        component: () => import('../views/note/NoteMovies.vue'),
        meta: { title: '电影' }
      },
      {
        path: 'movies/add',
        name: 'NoteMovieAdd',
        component: () => import('../views/note/NoteMovieEdit.vue'),
        meta: { title: '添加电影' }
      },
      {
        path: 'movies/:id',
        name: 'NoteMovieDetail',
        component: () => import('../views/note/NoteMovieDetail.vue'),
        meta: { title: '电影详情' }
      },
      {
        path: 'note-stats',
        name: 'NoteStats',
        component: () => import('../views/note/NoteStats.vue'),
        meta: { title: '笔记统计' }
      },
      {
        path: 'worldcup',
        name: 'WorldCup',
        component: () => import('../views/life/WorldCup.vue'),
        meta: { title: '2026世界杯' }
      }
    ]
  },
  {
    path: '/salary',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'list',
        name: 'SalaryList',
        component: () => import('../views/salary/SalaryList.vue'),
        meta: { title: '工资明细' }
      },
      {
        path: 'trend',
        name: 'SalaryTrend',
        component: () => import('../views/salary/SalaryTrend.vue'),
        meta: { title: '工资趋势图' }
      }
    ]
  },
  {
    path: '/system',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'users',
        name: 'UserList',
        component: () => import('../views/system/UserList.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'menu-manage',
        name: 'MenuManage',
        component: () => import('../views/system/MenuManage.vue'),
        meta: { title: '菜单管理' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'
  const isLoginPage = to.path === '/login'
  if (!isLoggedIn && !isLoginPage) {
    next('/login')
  } else {
    next()
  }
})

export default router

